module.exports = __webpack_public_path__ + "static/img/home_img_logo@2x.a651b70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImg/home_img_logo@2x.png
// module id = uR7+
// module chunks = 0